<template>
    <div class="panel-body text-center">
        <span v-if="tipo==1">
           <h3> Procesando...<i class="fas fa-spinner fa-pulse fa-3x"></i></h3> 
        </span>
        <span v-else>
           <h3> Procesando...<i class="fas fa-cog fa-spin fa-3x"></i></h3> 
        </span>
    </div>
</template>
<script>
export default {
    name:'ProcesandoComponent',
    props:['tipo']
}
</script>

